interface ConditionalWrapperProps {
  condition: boolean;
  wrapper: any;
  defaultWrapper: any;
}

export const ConditionalWrapper = (props: ConditionalWrapperProps, children) => [
  props.condition ? props.wrapper(children) : props.defaultWrapper(children)
];
